module.exports = __webpack_public_path__ + "assets/images/app-logo-c9dd91168ad1850b858470b6d6b77e5f.png";